/** Profile current status */
export enum ProfileStatusEnum {
  /** Profile inactive - cannot login or logout, can be used as contact person */
  INACTIVE = 'INACTIVE',
  /** Profile active - can login and logout, can be used as contact person */
  ACTIVE = 'ACTIVE',
  /** Profile inactive - cannot login or logout, cannot be used as contact person */
  SUSPENDED = 'SUSPENDED',
}
